import { Col, Container, Input, Label, Row } from "reactstrap";

//Common
import PageHeader from "../../common/PageHeader/PageHeader";
import ActionBar from "../../common/ActionBar/ActionBar";

//App
import { EmployeeImportFormProps } from "../../../types/organizationEmployee";
import useScreenSize from "../../hooks/useScreenSize";
import { IsSmallScreen } from "../../../utility/helpers";
import { getOrganizationId } from "../../../utility/helpers/claimHelper";
import { useState } from "react";
import { organizationApi } from "../../../app/model/api";
import ExportButton from "../../common/Buttons/ExportButton";

const Import: React.FC<EmployeeImportFormProps> = (props) => {
    const {
        uploadFile,
        setUploadFile,
        status: uploadStatus,
        handleUpload,
        fileInputRef,
    } = props;

    const [error, setError] = useState<string | null>(null);

    const windowWidth = useScreenSize();
    const isSmallScreen = IsSmallScreen(windowWidth);

    const handleFileUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
        setError(null);

        const file = e.target.files?.[0];

        if (!file) return;

        // File type validation
        if (
            !file.name.toLowerCase().endsWith(".xlsx") &&
            !file.name.toLowerCase().endsWith(".xls")
        ) {
            setError(
                "Invalid file type. Please upload an Excel file (.xlsx or .xls)."
            );
            return;
        }

        setUploadFile(file as File);
    };

    const saveInput = () => {
        handleUpload();
    };

    const downloadUrl = organizationApi.getOrganizationEmployeeUploadTemplate(
        getOrganizationId()
    );

    return (
        <>
            <PageHeader>Employee Upload</PageHeader>
            <div className="mt-4">
                <Row>
                    <Col xs="12" md="8" style={{ paddingTop: 20 }}>
                        <span>Select excel file to upload:</span>
                    </Col>
                    <Col xs="12" md="4" className={`d-flex justify-content-${isSmallScreen ? "start" : "end"} mb-3`} >
                        <ExportButton method="GET" url={downloadUrl} text="Download Template" fileName="Employee Upload Template" />
                    </Col>
                </Row>
                <Input
                    type="file"
                    accept=".xls,.xlsx"
                    innerRef={fileInputRef}
                    onChange={handleFileUpload}
                    invalid={!!error}
                    disabled={uploadStatus === "pending"}
                />
                {error && <p className="invalid-feedback">{error}</p>}

                <div className="ps-3 pt-2">
                    <i>*Any employees not included will be inactivated.</i><br />
                    <i> You will receive an email when your file is done processing.</i>
                </div>
                {uploadFile && (
                    <ActionBar
                        submitHandler={saveInput}
                        submitText="Upload"
                        isLoading={uploadStatus === "pending"}
                    />
                )}
            </div>
        </>
    );
};

export default Import;
